import AbstractApiModel from '@/models/abstracts/AbstractApiModel';

/** POST {token, plainPassword} : nouveau mot de passe à partir du lien reçu par e-mail */
export default class PasswordResetModel extends AbstractApiModel {
  protected _path = '/password_resets';
}
